import { Button } from "@nocios/presentation-kit";

import "./index.sass";
import Config from "src/Constants/Config";

interface CardProps {
  title: string | null;
  onClick?: () => void;
  image?: string;
}

const Card = ({ title, onClick, image }: CardProps) => {
  const format = (text: string) => ({ __html: text.replace(/\n/g, "<br>") });

  return (
    <>
      {title !== null ? (
        <div className="card-version-zero" onClick={onClick}>
          <div className="card-version-zero-body">
            <div>
              <div className="card-version-zero-body-title" dangerouslySetInnerHTML={format(title)} />
            </div>
            <div className="card-version-zero-btn">
              <Button label={"Start"} style={{ gap: "var(--width-16)" }} endIcon={{ icon: "arrow-left" }} type="next" />
              {image ? <img style={{ width: "var(--width-130)" }} src={`${Config.BASE_URL}/images/${image}`} alt="" /> : <div></div>}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default Card;
